import { useScrollReveal } from '@/hooks/useScrollReveal';

const tiers = [
  {
    id: 'discovery',
    name: 'The Diagnostic',
    price: '$250',
    desc: "One focused conversation where I diagnose what\u2019s actually broken and whether I\u2019m the right person to help fix it.",
  },
  {
    id: 'assessment',
    name: 'Founder Vulnerability Assessment',
    price: '$1,000\u2013$1,500',
    desc: 'A written analysis of your founding team dynamics, role alignment, and decision-making structure \u2014 the fractures that compound silently.',
  },
  {
    id: 'realignment',
    name: 'Realignment Engagement',
    price: '$2,500\u2013$5,000+',
    desc: 'A 30\u201360 day structured engagement scoped from the assessment: strategy repositioning, execution architecture, founder alignment, or funding readiness.',
  },
];

const OfferArchitecture = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      id="work-with-me"
      data-testid="offer-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-narrow">
        <p className="section-label" data-testid="offer-label">How we work together</p>

        <div className="mt-10 space-y-0">
          {tiers.map((t, i) => (
            <div key={t.id} className="offer-card" data-testid={`offer-tier-${i + 1}`}>
              <div className="flex flex-wrap items-baseline gap-x-3">
                <span className="offer-tier-name">{t.name}</span>
              </div>
              <p className="body-text-secondary mt-2">{t.desc}</p>
            </div>
          ))}
        </div>

        <p className="section-note mt-10" data-testid="offer-note">
          Also available: pitch readiness reviews, offer positioning teardowns, 30-day execution sprint plans. Scoped on request.
        </p>
      </div>
    </section>
  );
};

export default OfferArchitecture;
